import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";

export const FieldLabel = ({
  label,
  outstanding,
  required = false,
  edit = false,
}: {
  label: string;
  outstanding?: string;
  required?: boolean;
  edit?: boolean;
}) =>
  edit ? (
    <span>
      {label}
      {(required || outstanding) && (
        <span className="text-color-alert" aria-hidden="true">
          {" "}
          *
        </span>
      )}
    </span>
  ) : (
    <>
      {label}
      {outstanding && (
        <Tooltip title={outstanding} describeChild arrow>
          <span
            role="img"
            aria-label={`${label}: ${outstanding}`}
            tabIndex={0}
            onClick={(event) => event.preventDefault()}
            className="pointer-events-auto ml-1 inline-flex cursor-help align-middle [fieldset_&]:invisible"
          >
            <InfoOutlined color="error" fontSize="inherit" />
          </span>
        </Tooltip>
      )}
    </>
  );
